import { makeUniqueArray } from '../../../../utils/make-unique-array';
import { findItemByName } from './find-item-by-name';
export var findCurrentRoute = function (_a) {
    var routeUrl = _a.routeUrl, flattenMenuProductsList = _a.flattenMenuProductsList;
    return flattenMenuProductsList.find(function (productData) {
        // все проекты без конфигов будут забираться целиком всегда
        // и будут включены в другой фазе выбора
        if (!productData.config) {
            return false;
        }
        // проверяем урл домашней страницы
        if (productData.config.routePath === '/' && routeUrl === '/') {
            return true;
        }
        // получаем часть урла первую
        // например в урле /foo-bar/baz будет /foo-bar
        var firstRoutePart = routeUrl.replace(/^(\/[\w-]+)\/.*$/, '$1');
        return productData.config.routePath && productData.config.routePath !== '/'
            ? firstRoutePart === productData.config.routePath
            : false;
    });
};
export var getAdditionalRoutes = function (_a) {
    var flattenMenuProductsList = _a.flattenMenuProductsList, additionalProductsData = _a.additionalProductsData;
    return additionalProductsData.reduce(function (acc, _a) {
        var name = _a.name;
        var menuProductConfigInFullList = findItemByName({
            items: flattenMenuProductsList,
            nameToFind: name,
        });
        if (menuProductConfigInFullList.staticURL) {
            acc.push(menuProductConfigInFullList);
        }
        return acc;
    }, []);
};
export var getRoutesWithoutInlinedConfig = function (flattenMenuProductsList) {
    var routes = flattenMenuProductsList.filter(function (productData) {
        return !productData.absoluteURL &&
            !productData.relativeURL &&
            !productData.config;
    });
    // роуты могут иметь разные группы для позиционирования в разных виджетах
    // но внутри иметь один staticURL - нужно убрать дубликаты для загрузки
    var resultRoutes = makeUniqueArray({
        array: routes,
        fieldName: 'staticURL',
    });
    return resultRoutes;
};
export var getRoutesWithoutCompleteConfig = function (flattenMenuProductsList) {
    return flattenMenuProductsList.filter(function (productData) {
        return !productData.absoluteURL &&
            !productData.relativeURL &&
            productData.config &&
            (!productData.config.routeName || !productData.config.routePath);
    });
};
